var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"top-wrapper"},[_c('span',{staticClass:"span1"},[_vm._v(_vm._s(_vm.$t('Home.Top.span1')))]),_c('span',{staticClass:"span2"},[_vm._v(_vm._s(_vm.$t('Home.Top.span2')))]),_vm._m(0),_c('div',{staticClass:"top-right"})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"top-left"},[_c('div',{staticClass:"left-shape1"}),_c('div',{staticClass:"left-shape2"})])
}]

export { render, staticRenderFns }